<script setup lang="ts">
import focusable from 'focusable';

const focusTrap = ref<HTMLElement>();
const lastExternalElement = ref<HTMLElement | null>();

const props = defineProps<{
  class?: string;
}>();

function focusLastElement() {
  const focusableElements = focusTrap.value?.querySelectorAll(focusable);
  focusableElements?.[focusableElements.length - 1].focus();
}

function focusFirstElement() {
  const focusableElements = focusTrap.value?.querySelectorAll(focusable);
  focusableElements?.[0].focus();
}

onMounted(() => {
  nextTick(() => {
    lastExternalElement.value = document.hasFocus()
      ? (document.activeElement as HTMLElement)
      : null;
    focusFirstElement();
  });
});

onUnmounted(() => {
  if (lastExternalElement.value) {
    lastExternalElement.value.focus();
  }
});
</script>

<template>
  <div tabindex="0" @focusin="focusLastElement" />
  <div ref="focusTrap" :class="props.class">
    <slot />
  </div>
  <div tabindex="0" @focusin="focusFirstElement" />
</template>
